"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useGetApiClient = require("./useGetApiClient");

Object.keys(_useGetApiClient).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetApiClient[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetApiClient[key];
    }
  });
});